import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-eyecatcher",
    styleUrl: "eyecatcher.scss",
    shadow: true
})
export class Eyecatcher {
    /**
     * The variant of the eyecatcher.
     */
    @Prop() readonly variant!: "blue" | "bold" | "round" | "plain";
    render() {
        return (
            <Host variant={this.variant}>
                <slot />
            </Host>
        );
    }
}
